<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M12.6788 1.93462L10.5 0.5L8.32559 1.93462C8.26105 1.97683 8.18481 1.99741 8.10785 1.99368L5.50222 1.84843L4.32662 4.16858C4.29205 4.23722 4.23637 4.29291 4.16775 4.32749L1.84812 5.49874L1.99334 8.10497C1.99707 8.18194 1.9765 8.2582 1.93447 8.32294L0.5 10.5023L1.93447 12.677C1.9765 12.7417 1.99707 12.8178 1.99334 12.895L1.84812 15.501L4.16775 16.6724C4.23637 16.707 4.29205 16.7627 4.32662 16.8313L5.49778 19.1515L8.10324 19.0061H8.12133C8.19208 19.007 8.26141 19.0274 8.32116 19.0651L10.4954 20.4999L12.6698 19.0651C12.7343 19.0231 12.8106 19.0025 12.8875 19.0061L15.4932 19.1515L16.6643 16.8313C16.6989 16.7627 16.7546 16.707 16.8232 16.6724L19.1427 15.501L18.9974 12.895C19.0013 12.8176 19.0247 12.7426 19.0655 12.677L20.5 10.5023L19.0655 8.32737C19.0235 8.26281 19.0028 8.18655 19.0065 8.1094L19.1517 5.50335L16.8323 4.32749C16.7636 4.29291 16.708 4.23722 16.6734 4.16858L15.5022 1.84843L12.8968 1.99368C12.8196 1.99741 12.7434 1.97683 12.6788 1.93462ZM3.80938 10.5022C3.80938 6.81096 6.80989 3.80977 10.5003 3.80977C14.1908 3.80977 17.1911 6.81096 17.1911 10.5022C17.1911 14.1933 14.1908 17.1945 10.5003 17.1945C6.80989 17.1945 3.80938 14.1933 3.80938 10.5022ZM10.5006 4.53633C13.7916 4.53633 16.4651 7.21509 16.4651 10.5024C16.4651 13.7895 13.787 16.4682 10.5006 16.4682C7.21409 16.4682 4.53594 13.7895 4.53594 10.5024C4.53594 7.21509 7.20966 4.53633 10.5006 4.53633ZM12.9924 8.54529C13.1378 8.4073 13.3674 8.41351 13.5054 8.55894C13.6433 8.70437 13.6371 8.93405 13.4917 9.07203L9.89207 12.468C9.82557 12.5333 9.73567 12.5693 9.64241 12.5681C9.54488 12.5689 9.45126 12.5296 9.38371 12.459L7.49992 10.5249C7.36197 10.3816 7.36498 10.1537 7.50701 10.0143C7.64886 9.87491 7.87653 9.8758 8.0175 10.0163L9.65163 11.6962L12.9924 8.54529Z"
				:fill="color" 
			/>
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgCertificat',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>